import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { default as TooltipButton } from 'react-bootstrap/Button';

/* Icons */
import InfoIcon from '~/../symbols/info.svg';

/* Common */
import { Icon } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionFieldChoiceSubscription(props) {
    const { colClassName, formGroupClassName = '', customControlClassName = '', field, inputType, path, id, updateChoice } = props;
    const { type, label, choices, required, disabled, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name} ${formGroupClassName}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {choices?.map((choice, choiceIndex) => {
                    return (
                        <Form.Check
                            key={choice.key}
                            className={`custom-control custom-${inputType} ${customControlClassName} ${error ? 'is-error' : ''}`}
                            type={inputType}
                            id={`${id}.choices.${choiceIndex}-${choice.key}`}
                        >
                            <Form.Check.Input
                                type={inputType}
                                className="custom-control-input"
                                name={id}
                                value={choice.key}
                                {...{
                                    required,
                                    disabled,
                                }}
                                checked={value?.includes(choice.key)}
                                onChange={(e) => {
                                    updateChoice(choice, e.target.checked, () => {
                                        trigger(path);
                                    });
                                }}
                            />
                            <Form.Check.Label className="custom-control-label h-100">
                                <div className="d-block d-xl-flex align-items-center ml-8">
                                    <div className="d-flex align-items-center">
                                        <span className="text--md font-weight-bold" dangerouslySetInnerHTML={{ __html: choice.label }} />
                                        {choice.tooltip && (
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={
                                                    <Tooltip id={`tooltip-${id}.choices.${choiceIndex}-${choice.key}`}>
                                                        {choice.tooltip}
                                                    </Tooltip>
                                                }
                                            >
                                                <TooltipButton
                                                    variant="none"
                                                    className="ml-2 p-0 d-block"
                                                >
                                                    <Icon
                                                        theme="base"
                                                        size={14}
                                                        url={InfoIcon?.url}
                                                        className={``}
                                                    />
                                                </TooltipButton>
                                            </OverlayTrigger>
                                        )}
                                    </div>
                                    {choice?.most_chosen && (
                                        <div className="card__label">{trans(`app.flow.most_chosen`)}</div>
                                    )}
                                </div>
                                {choice?.['pay-off'] && (
                                    <span className="custom-control-label__pay-off">{choice?.['pay-off']}</span>
                                )}
                                {(choice.price || choice.vat_text) && (
                                    <div className="line-height-1">
                                        {choice.price && (
                                            <p className="text-primary font-weight-bold text--sm mb-0 mt-1 text-right">{choice.price}</p>
                                        )}
                                        {choice.vat_text && (
                                            <p className="text--xs text-muted--60 mb-0 mt-1 text-right font-weight-normal">{choice.vat_text}</p>
                                        )}
                                    </div>
                                )}
                            </Form.Check.Label>
                        </Form.Check>
                    );
                })}
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
